/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfByteOf } from '../models/custom-result-of-byte-of';
import { CustomResultOfPaginatedListOfGetExcelsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-excels-with-pagination-dto';
import { CustomResultOfString } from '../models/custom-result-of-string';
import { excelCreateBlackListsExcelGet } from '../fn/excel/excel-create-black-lists-excel-get';
import { ExcelCreateBlackListsExcelGet$Params } from '../fn/excel/excel-create-black-lists-excel-get';
import { excelCreateBlackListsExcelPost } from '../fn/excel/excel-create-black-lists-excel-post';
import { ExcelCreateBlackListsExcelPost$Params } from '../fn/excel/excel-create-black-lists-excel-post';
import { excelCreateContactsExcelByPhonebookIdGet } from '../fn/excel/excel-create-contacts-excel-by-phonebook-id-get';
import { ExcelCreateContactsExcelByPhonebookIdGet$Params } from '../fn/excel/excel-create-contacts-excel-by-phonebook-id-get';
import { excelCreateContactsExcelByPhonebookIdPost } from '../fn/excel/excel-create-contacts-excel-by-phonebook-id-post';
import { ExcelCreateContactsExcelByPhonebookIdPost$Params } from '../fn/excel/excel-create-contacts-excel-by-phonebook-id-post';
import { excelCreateFormBuilderResponsesExcelGet } from '../fn/excel/excel-create-form-builder-responses-excel-get';
import { ExcelCreateFormBuilderResponsesExcelGet$Params } from '../fn/excel/excel-create-form-builder-responses-excel-get';
import { excelCreateFormBuilderResponsesExcelPost } from '../fn/excel/excel-create-form-builder-responses-excel-post';
import { ExcelCreateFormBuilderResponsesExcelPost$Params } from '../fn/excel/excel-create-form-builder-responses-excel-post';
import { excelCreateInboxesExcelByPollParserGet } from '../fn/excel/excel-create-inboxes-excel-by-poll-parser-get';
import { ExcelCreateInboxesExcelByPollParserGet$Params } from '../fn/excel/excel-create-inboxes-excel-by-poll-parser-get';
import { excelCreateInboxesExcelByPollParserPost } from '../fn/excel/excel-create-inboxes-excel-by-poll-parser-post';
import { ExcelCreateInboxesExcelByPollParserPost$Params } from '../fn/excel/excel-create-inboxes-excel-by-poll-parser-post';
import { excelCreateInboxesExcelByTextParserGet } from '../fn/excel/excel-create-inboxes-excel-by-text-parser-get';
import { ExcelCreateInboxesExcelByTextParserGet$Params } from '../fn/excel/excel-create-inboxes-excel-by-text-parser-get';
import { excelCreateInboxesExcelByTextParserPost } from '../fn/excel/excel-create-inboxes-excel-by-text-parser-post';
import { ExcelCreateInboxesExcelByTextParserPost$Params } from '../fn/excel/excel-create-inboxes-excel-by-text-parser-post';
import { excelCreateInboxesExcelGet } from '../fn/excel/excel-create-inboxes-excel-get';
import { ExcelCreateInboxesExcelGet$Params } from '../fn/excel/excel-create-inboxes-excel-get';
import { excelCreateInboxesExcelPost } from '../fn/excel/excel-create-inboxes-excel-post';
import { ExcelCreateInboxesExcelPost$Params } from '../fn/excel/excel-create-inboxes-excel-post';
import { excelCreateOrganizationExcelGet } from '../fn/excel/excel-create-organization-excel-get';
import { ExcelCreateOrganizationExcelGet$Params } from '../fn/excel/excel-create-organization-excel-get';
import { excelCreateOrganizationExcelPost } from '../fn/excel/excel-create-organization-excel-post';
import { ExcelCreateOrganizationExcelPost$Params } from '../fn/excel/excel-create-organization-excel-post';
import { excelCreateOutboxMessagesExcelGet } from '../fn/excel/excel-create-outbox-messages-excel-get';
import { ExcelCreateOutboxMessagesExcelGet$Params } from '../fn/excel/excel-create-outbox-messages-excel-get';
import { excelCreateOutboxMessagesExcelPost } from '../fn/excel/excel-create-outbox-messages-excel-post';
import { ExcelCreateOutboxMessagesExcelPost$Params } from '../fn/excel/excel-create-outbox-messages-excel-post';
import { excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsGet } from '../fn/excel/excel-create-outbox-messages-excel-with-separated-delivery-columns-get';
import { ExcelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsGet$Params } from '../fn/excel/excel-create-outbox-messages-excel-with-separated-delivery-columns-get';
import { excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsPost } from '../fn/excel/excel-create-outbox-messages-excel-with-separated-delivery-columns-post';
import { ExcelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsPost$Params } from '../fn/excel/excel-create-outbox-messages-excel-with-separated-delivery-columns-post';
import { excelCreatePaymentsExcelGet } from '../fn/excel/excel-create-payments-excel-get';
import { ExcelCreatePaymentsExcelGet$Params } from '../fn/excel/excel-create-payments-excel-get';
import { excelCreatePaymentsExcelPost } from '../fn/excel/excel-create-payments-excel-post';
import { ExcelCreatePaymentsExcelPost$Params } from '../fn/excel/excel-create-payments-excel-post';
import { excelCreateReceiversExcelGet } from '../fn/excel/excel-create-receivers-excel-get';
import { ExcelCreateReceiversExcelGet$Params } from '../fn/excel/excel-create-receivers-excel-get';
import { excelCreateReceiversExcelPost } from '../fn/excel/excel-create-receivers-excel-post';
import { ExcelCreateReceiversExcelPost$Params } from '../fn/excel/excel-create-receivers-excel-post';
import { excelCreateResellerTransactionsExcelGet } from '../fn/excel/excel-create-reseller-transactions-excel-get';
import { ExcelCreateResellerTransactionsExcelGet$Params } from '../fn/excel/excel-create-reseller-transactions-excel-get';
import { excelCreateResellerTransactionsExcelPost } from '../fn/excel/excel-create-reseller-transactions-excel-post';
import { ExcelCreateResellerTransactionsExcelPost$Params } from '../fn/excel/excel-create-reseller-transactions-excel-post';
import { excelCreateSmartSmsRequestRecipientsExcelGet } from '../fn/excel/excel-create-smart-sms-request-recipients-excel-get';
import { ExcelCreateSmartSmsRequestRecipientsExcelGet$Params } from '../fn/excel/excel-create-smart-sms-request-recipients-excel-get';
import { excelCreateSmartSmsRequestRecipientsExcelPost } from '../fn/excel/excel-create-smart-sms-request-recipients-excel-post';
import { ExcelCreateSmartSmsRequestRecipientsExcelPost$Params } from '../fn/excel/excel-create-smart-sms-request-recipients-excel-post';
import { excelCreateSmartSmsRequestsExcelGet } from '../fn/excel/excel-create-smart-sms-requests-excel-get';
import { ExcelCreateSmartSmsRequestsExcelGet$Params } from '../fn/excel/excel-create-smart-sms-requests-excel-get';
import { excelCreateSmartSmsRequestsExcelPost } from '../fn/excel/excel-create-smart-sms-requests-excel-post';
import { ExcelCreateSmartSmsRequestsExcelPost$Params } from '../fn/excel/excel-create-smart-sms-requests-excel-post';
import { excelCreateSmartSmsStatisticsExcelGet } from '../fn/excel/excel-create-smart-sms-statistics-excel-get';
import { ExcelCreateSmartSmsStatisticsExcelGet$Params } from '../fn/excel/excel-create-smart-sms-statistics-excel-get';
import { excelCreateSmartSmsStatisticsExcelPost } from '../fn/excel/excel-create-smart-sms-statistics-excel-post';
import { ExcelCreateSmartSmsStatisticsExcelPost$Params } from '../fn/excel/excel-create-smart-sms-statistics-excel-post';
import { excelCreateTransactionsExcelGet } from '../fn/excel/excel-create-transactions-excel-get';
import { ExcelCreateTransactionsExcelGet$Params } from '../fn/excel/excel-create-transactions-excel-get';
import { excelCreateTransactionsExcelPost } from '../fn/excel/excel-create-transactions-excel-post';
import { ExcelCreateTransactionsExcelPost$Params } from '../fn/excel/excel-create-transactions-excel-post';
import { excelCreateUsersByResellerExcel } from '../fn/excel/excel-create-users-by-reseller-excel';
import { ExcelCreateUsersByResellerExcel$Params } from '../fn/excel/excel-create-users-by-reseller-excel';
import { excelCreateUsersExcelGet } from '../fn/excel/excel-create-users-excel-get';
import { ExcelCreateUsersExcelGet$Params } from '../fn/excel/excel-create-users-excel-get';
import { excelCreateUsersExcelPost } from '../fn/excel/excel-create-users-excel-post';
import { ExcelCreateUsersExcelPost$Params } from '../fn/excel/excel-create-users-excel-post';
import { excelDownload } from '../fn/excel/excel-download';
import { ExcelDownload$Params } from '../fn/excel/excel-download';
import { excelGetExcelAudits } from '../fn/excel/excel-get-excel-audits';
import { ExcelGetExcelAudits$Params } from '../fn/excel/excel-get-excel-audits';
import { excelGetExcelsWithPagination } from '../fn/excel/excel-get-excels-with-pagination';
import { ExcelGetExcelsWithPagination$Params } from '../fn/excel/excel-get-excels-with-pagination';
import { excelUpdateStatus } from '../fn/excel/excel-update-status';
import { ExcelUpdateStatus$Params } from '../fn/excel/excel-update-status';
import { excelUpdateStatusToArchive } from '../fn/excel/excel-update-status-to-archive';
import { ExcelUpdateStatusToArchive$Params } from '../fn/excel/excel-update-status-to-archive';

@Injectable({ providedIn: 'root' })
export class ExcelService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `excelGetExcelAudits()` */
  static readonly ExcelGetExcelAuditsPath = '/Excel/GetExcelAudits';

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelGetExcelAudits()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelGetExcelAudits$Response(params: ExcelGetExcelAudits$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return excelGetExcelAudits(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelGetExcelAudits$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelGetExcelAudits(params: ExcelGetExcelAudits$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.excelGetExcelAudits$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `excelCreateReceiversExcelGet()` */
  static readonly ExcelCreateReceiversExcelGetPath = '/Excel/CreateReceiversExcel';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateReceiversExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateReceiversExcelGet$Response(params?: ExcelCreateReceiversExcelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreateReceiversExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateReceiversExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateReceiversExcelGet(params?: ExcelCreateReceiversExcelGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreateReceiversExcelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreateReceiversExcelPost()` */
  static readonly ExcelCreateReceiversExcelPostPath = '/Excel/CreateReceiversExcel';

  /**
   * Create Receivers Excel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateReceiversExcelPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateReceiversExcelPost$Response(params: ExcelCreateReceiversExcelPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreateReceiversExcelPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Receivers Excel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateReceiversExcelPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateReceiversExcelPost(params: ExcelCreateReceiversExcelPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreateReceiversExcelPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelCreateContactsExcelByPhonebookIdGet()` */
  static readonly ExcelCreateContactsExcelByPhonebookIdGetPath = '/Excel/CreateContactsExcelByPhonebookId';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateContactsExcelByPhonebookIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateContactsExcelByPhonebookIdGet$Response(params?: ExcelCreateContactsExcelByPhonebookIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreateContactsExcelByPhonebookIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateContactsExcelByPhonebookIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateContactsExcelByPhonebookIdGet(params?: ExcelCreateContactsExcelByPhonebookIdGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreateContactsExcelByPhonebookIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreateContactsExcelByPhonebookIdPost()` */
  static readonly ExcelCreateContactsExcelByPhonebookIdPostPath = '/Excel/CreateContactsExcelByPhonebookId';

  /**
   * Create Contacts Excel By Phonebook Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateContactsExcelByPhonebookIdPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateContactsExcelByPhonebookIdPost$Response(params: ExcelCreateContactsExcelByPhonebookIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreateContactsExcelByPhonebookIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Contacts Excel By Phonebook Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateContactsExcelByPhonebookIdPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateContactsExcelByPhonebookIdPost(params: ExcelCreateContactsExcelByPhonebookIdPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreateContactsExcelByPhonebookIdPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelCreateBlackListsExcelGet()` */
  static readonly ExcelCreateBlackListsExcelGetPath = '/Excel/CreateBlackListsExcel';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateBlackListsExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateBlackListsExcelGet$Response(params?: ExcelCreateBlackListsExcelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreateBlackListsExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateBlackListsExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateBlackListsExcelGet(params?: ExcelCreateBlackListsExcelGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreateBlackListsExcelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreateBlackListsExcelPost()` */
  static readonly ExcelCreateBlackListsExcelPostPath = '/Excel/CreateBlackListsExcel';

  /**
   * Create BlackLists Excel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateBlackListsExcelPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateBlackListsExcelPost$Response(params: ExcelCreateBlackListsExcelPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfString>> {
    return excelCreateBlackListsExcelPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create BlackLists Excel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateBlackListsExcelPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateBlackListsExcelPost(params: ExcelCreateBlackListsExcelPost$Params, context?: HttpContext): Observable<CustomResultOfString> {
    return this.excelCreateBlackListsExcelPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfString>): CustomResultOfString => r.body)
    );
  }

  /** Path part for operation `excelCreateInboxesExcelGet()` */
  static readonly ExcelCreateInboxesExcelGetPath = '/Excel/CreateInboxesExcel';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateInboxesExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateInboxesExcelGet$Response(params?: ExcelCreateInboxesExcelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreateInboxesExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateInboxesExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateInboxesExcelGet(params?: ExcelCreateInboxesExcelGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreateInboxesExcelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreateInboxesExcelPost()` */
  static readonly ExcelCreateInboxesExcelPostPath = '/Excel/CreateInboxesExcel';

  /**
   * درخواست برای ساختن اکسل صندوق دریافت.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateInboxesExcelPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateInboxesExcelPost$Response(params: ExcelCreateInboxesExcelPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreateInboxesExcelPost(this.http, this.rootUrl, params, context);
  }

  /**
   * درخواست برای ساختن اکسل صندوق دریافت.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateInboxesExcelPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateInboxesExcelPost(params: ExcelCreateInboxesExcelPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreateInboxesExcelPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelCreateInboxesExcelByPollParserGet()` */
  static readonly ExcelCreateInboxesExcelByPollParserGetPath = '/Excel/CreateInboxesExcelByPollParser';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateInboxesExcelByPollParserGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateInboxesExcelByPollParserGet$Response(params?: ExcelCreateInboxesExcelByPollParserGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreateInboxesExcelByPollParserGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateInboxesExcelByPollParserGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateInboxesExcelByPollParserGet(params?: ExcelCreateInboxesExcelByPollParserGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreateInboxesExcelByPollParserGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreateInboxesExcelByPollParserPost()` */
  static readonly ExcelCreateInboxesExcelByPollParserPostPath = '/Excel/CreateInboxesExcelByPollParser';

  /**
   * درخواست برای ساختن اکسل صندوق دریافت بر اساس شناسه مسابقه یا نظرسنجی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateInboxesExcelByPollParserPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateInboxesExcelByPollParserPost$Response(params: ExcelCreateInboxesExcelByPollParserPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreateInboxesExcelByPollParserPost(this.http, this.rootUrl, params, context);
  }

  /**
   * درخواست برای ساختن اکسل صندوق دریافت بر اساس شناسه مسابقه یا نظرسنجی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateInboxesExcelByPollParserPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateInboxesExcelByPollParserPost(params: ExcelCreateInboxesExcelByPollParserPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreateInboxesExcelByPollParserPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelCreateInboxesExcelByTextParserGet()` */
  static readonly ExcelCreateInboxesExcelByTextParserGetPath = '/Excel/CreateInboxesExcelByTextParser';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateInboxesExcelByTextParserGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateInboxesExcelByTextParserGet$Response(params?: ExcelCreateInboxesExcelByTextParserGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreateInboxesExcelByTextParserGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateInboxesExcelByTextParserGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateInboxesExcelByTextParserGet(params?: ExcelCreateInboxesExcelByTextParserGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreateInboxesExcelByTextParserGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreateInboxesExcelByTextParserPost()` */
  static readonly ExcelCreateInboxesExcelByTextParserPostPath = '/Excel/CreateInboxesExcelByTextParser';

  /**
   * درخواست برای ساختن اکسل صندوق دریافت بر اساس شناسه تحلیلگر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateInboxesExcelByTextParserPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateInboxesExcelByTextParserPost$Response(params: ExcelCreateInboxesExcelByTextParserPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreateInboxesExcelByTextParserPost(this.http, this.rootUrl, params, context);
  }

  /**
   * درخواست برای ساختن اکسل صندوق دریافت بر اساس شناسه تحلیلگر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateInboxesExcelByTextParserPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateInboxesExcelByTextParserPost(params: ExcelCreateInboxesExcelByTextParserPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreateInboxesExcelByTextParserPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelCreateOutboxMessagesExcelGet()` */
  static readonly ExcelCreateOutboxMessagesExcelGetPath = '/Excel/CreateOutboxMessagesExcel';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateOutboxMessagesExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateOutboxMessagesExcelGet$Response(params?: ExcelCreateOutboxMessagesExcelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreateOutboxMessagesExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateOutboxMessagesExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateOutboxMessagesExcelGet(params?: ExcelCreateOutboxMessagesExcelGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreateOutboxMessagesExcelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreateOutboxMessagesExcelPost()` */
  static readonly ExcelCreateOutboxMessagesExcelPostPath = '/Excel/CreateOutboxMessagesExcel';

  /**
   * درخواست برای ساختن اکسل صندوق ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateOutboxMessagesExcelPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateOutboxMessagesExcelPost$Response(params: ExcelCreateOutboxMessagesExcelPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreateOutboxMessagesExcelPost(this.http, this.rootUrl, params, context);
  }

  /**
   * درخواست برای ساختن اکسل صندوق ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateOutboxMessagesExcelPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateOutboxMessagesExcelPost(params: ExcelCreateOutboxMessagesExcelPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreateOutboxMessagesExcelPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsGet()` */
  static readonly ExcelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsGetPath = '/Excel/CreateOutboxMessagesExcelWithSeparatedDeliveryColumns';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsGet$Response(params?: ExcelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsGet(params?: ExcelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsPost()` */
  static readonly ExcelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsPostPath = '/Excel/CreateOutboxMessagesExcelWithSeparatedDeliveryColumns';

  /**
   * درخواست برای ساختن اکسل صندوق ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsPost$Response(params: ExcelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * درخواست برای ساختن اکسل صندوق ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsPost(params: ExcelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelCreateUsersExcelGet()` */
  static readonly ExcelCreateUsersExcelGetPath = '/Excel/CreateUsersExcel';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateUsersExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateUsersExcelGet$Response(params?: ExcelCreateUsersExcelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreateUsersExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateUsersExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateUsersExcelGet(params?: ExcelCreateUsersExcelGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreateUsersExcelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreateUsersExcelPost()` */
  static readonly ExcelCreateUsersExcelPostPath = '/Excel/CreateUsersExcel';

  /**
   * درخواست برای ساختن اکسل کاربران.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateUsersExcelPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateUsersExcelPost$Response(params: ExcelCreateUsersExcelPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreateUsersExcelPost(this.http, this.rootUrl, params, context);
  }

  /**
   * درخواست برای ساختن اکسل کاربران.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateUsersExcelPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateUsersExcelPost(params: ExcelCreateUsersExcelPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreateUsersExcelPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelCreateUsersByResellerExcel()` */
  static readonly ExcelCreateUsersByResellerExcelPath = '/Excel/CreateUsersByResellerExcel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateUsersByResellerExcel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateUsersByResellerExcel$Response(params: ExcelCreateUsersByResellerExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreateUsersByResellerExcel(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateUsersByResellerExcel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateUsersByResellerExcel(params: ExcelCreateUsersByResellerExcel$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreateUsersByResellerExcel$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelCreateTransactionsExcelGet()` */
  static readonly ExcelCreateTransactionsExcelGetPath = '/Excel/CreateTransactionsExcel';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateTransactionsExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateTransactionsExcelGet$Response(params?: ExcelCreateTransactionsExcelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreateTransactionsExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateTransactionsExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateTransactionsExcelGet(params?: ExcelCreateTransactionsExcelGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreateTransactionsExcelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreateTransactionsExcelPost()` */
  static readonly ExcelCreateTransactionsExcelPostPath = '/Excel/CreateTransactionsExcel';

  /**
   * درخواست برای ساختن اکسل تراکنش ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateTransactionsExcelPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateTransactionsExcelPost$Response(params: ExcelCreateTransactionsExcelPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreateTransactionsExcelPost(this.http, this.rootUrl, params, context);
  }

  /**
   * درخواست برای ساختن اکسل تراکنش ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateTransactionsExcelPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateTransactionsExcelPost(params: ExcelCreateTransactionsExcelPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreateTransactionsExcelPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelCreateResellerTransactionsExcelGet()` */
  static readonly ExcelCreateResellerTransactionsExcelGetPath = '/Excel/CreateResellerTransactionsExcel';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateResellerTransactionsExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateResellerTransactionsExcelGet$Response(params?: ExcelCreateResellerTransactionsExcelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreateResellerTransactionsExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateResellerTransactionsExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateResellerTransactionsExcelGet(params?: ExcelCreateResellerTransactionsExcelGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreateResellerTransactionsExcelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreateResellerTransactionsExcelPost()` */
  static readonly ExcelCreateResellerTransactionsExcelPostPath = '/Excel/CreateResellerTransactionsExcel';

  /**
   * درخواست برای ساختن اکسل تراکنش های فروشنده.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateResellerTransactionsExcelPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateResellerTransactionsExcelPost$Response(params: ExcelCreateResellerTransactionsExcelPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreateResellerTransactionsExcelPost(this.http, this.rootUrl, params, context);
  }

  /**
   * درخواست برای ساختن اکسل تراکنش های فروشنده.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateResellerTransactionsExcelPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateResellerTransactionsExcelPost(params: ExcelCreateResellerTransactionsExcelPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreateResellerTransactionsExcelPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelCreatePaymentsExcelGet()` */
  static readonly ExcelCreatePaymentsExcelGetPath = '/Excel/CreatePaymentsExcel';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreatePaymentsExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreatePaymentsExcelGet$Response(params?: ExcelCreatePaymentsExcelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreatePaymentsExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreatePaymentsExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreatePaymentsExcelGet(params?: ExcelCreatePaymentsExcelGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreatePaymentsExcelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreatePaymentsExcelPost()` */
  static readonly ExcelCreatePaymentsExcelPostPath = '/Excel/CreatePaymentsExcel';

  /**
   * درخواست برای ساختن اکسل پرداخت ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreatePaymentsExcelPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreatePaymentsExcelPost$Response(params: ExcelCreatePaymentsExcelPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreatePaymentsExcelPost(this.http, this.rootUrl, params, context);
  }

  /**
   * درخواست برای ساختن اکسل پرداخت ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreatePaymentsExcelPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreatePaymentsExcelPost(params: ExcelCreatePaymentsExcelPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreatePaymentsExcelPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelCreateSmartSmsStatisticsExcelGet()` */
  static readonly ExcelCreateSmartSmsStatisticsExcelGetPath = '/Excel/CreateSmartSmsStatisticsExcel';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateSmartSmsStatisticsExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateSmartSmsStatisticsExcelGet$Response(params?: ExcelCreateSmartSmsStatisticsExcelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreateSmartSmsStatisticsExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateSmartSmsStatisticsExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateSmartSmsStatisticsExcelGet(params?: ExcelCreateSmartSmsStatisticsExcelGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreateSmartSmsStatisticsExcelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreateSmartSmsStatisticsExcelPost()` */
  static readonly ExcelCreateSmartSmsStatisticsExcelPostPath = '/Excel/CreateSmartSmsStatisticsExcel';

  /**
   * درخواست برای ساختن اکسل آمار کمپین هوشمند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateSmartSmsStatisticsExcelPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateSmartSmsStatisticsExcelPost$Response(params: ExcelCreateSmartSmsStatisticsExcelPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreateSmartSmsStatisticsExcelPost(this.http, this.rootUrl, params, context);
  }

  /**
   * درخواست برای ساختن اکسل آمار کمپین هوشمند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateSmartSmsStatisticsExcelPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateSmartSmsStatisticsExcelPost(params: ExcelCreateSmartSmsStatisticsExcelPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreateSmartSmsStatisticsExcelPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelCreateOrganizationExcelGet()` */
  static readonly ExcelCreateOrganizationExcelGetPath = '/Excel/CreateOrganizationExcel';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateOrganizationExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateOrganizationExcelGet$Response(params?: ExcelCreateOrganizationExcelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreateOrganizationExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateOrganizationExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateOrganizationExcelGet(params?: ExcelCreateOrganizationExcelGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreateOrganizationExcelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreateOrganizationExcelPost()` */
  static readonly ExcelCreateOrganizationExcelPostPath = '/Excel/CreateOrganizationExcel';

  /**
   * درخواست برای ساختن اکسل سازمان ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateOrganizationExcelPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateOrganizationExcelPost$Response(params: ExcelCreateOrganizationExcelPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreateOrganizationExcelPost(this.http, this.rootUrl, params, context);
  }

  /**
   * درخواست برای ساختن اکسل سازمان ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateOrganizationExcelPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateOrganizationExcelPost(params: ExcelCreateOrganizationExcelPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreateOrganizationExcelPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelCreateSmartSmsRequestsExcelGet()` */
  static readonly ExcelCreateSmartSmsRequestsExcelGetPath = '/Excel/CreateSmartSmsRequestsExcel';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateSmartSmsRequestsExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateSmartSmsRequestsExcelGet$Response(params?: ExcelCreateSmartSmsRequestsExcelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreateSmartSmsRequestsExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateSmartSmsRequestsExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateSmartSmsRequestsExcelGet(params?: ExcelCreateSmartSmsRequestsExcelGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreateSmartSmsRequestsExcelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreateSmartSmsRequestsExcelPost()` */
  static readonly ExcelCreateSmartSmsRequestsExcelPostPath = '/Excel/CreateSmartSmsRequestsExcel';

  /**
   * درخواست برای ساختن اکسل درخواست ارسال هوشمند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateSmartSmsRequestsExcelPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateSmartSmsRequestsExcelPost$Response(params: ExcelCreateSmartSmsRequestsExcelPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreateSmartSmsRequestsExcelPost(this.http, this.rootUrl, params, context);
  }

  /**
   * درخواست برای ساختن اکسل درخواست ارسال هوشمند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateSmartSmsRequestsExcelPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateSmartSmsRequestsExcelPost(params: ExcelCreateSmartSmsRequestsExcelPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreateSmartSmsRequestsExcelPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelCreateSmartSmsRequestRecipientsExcelGet()` */
  static readonly ExcelCreateSmartSmsRequestRecipientsExcelGetPath = '/Excel/CreateSmartSmsRequestRecipientsExcel';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateSmartSmsRequestRecipientsExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateSmartSmsRequestRecipientsExcelGet$Response(params?: ExcelCreateSmartSmsRequestRecipientsExcelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreateSmartSmsRequestRecipientsExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateSmartSmsRequestRecipientsExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateSmartSmsRequestRecipientsExcelGet(params?: ExcelCreateSmartSmsRequestRecipientsExcelGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreateSmartSmsRequestRecipientsExcelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreateSmartSmsRequestRecipientsExcelPost()` */
  static readonly ExcelCreateSmartSmsRequestRecipientsExcelPostPath = '/Excel/CreateSmartSmsRequestRecipientsExcel';

  /**
   * درخواست برای ساختن اکسل جزییات درخواست ارسال هوشمند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateSmartSmsRequestRecipientsExcelPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateSmartSmsRequestRecipientsExcelPost$Response(params: ExcelCreateSmartSmsRequestRecipientsExcelPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreateSmartSmsRequestRecipientsExcelPost(this.http, this.rootUrl, params, context);
  }

  /**
   * درخواست برای ساختن اکسل جزییات درخواست ارسال هوشمند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateSmartSmsRequestRecipientsExcelPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateSmartSmsRequestRecipientsExcelPost(params: ExcelCreateSmartSmsRequestRecipientsExcelPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreateSmartSmsRequestRecipientsExcelPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelCreateFormBuilderResponsesExcelGet()` */
  static readonly ExcelCreateFormBuilderResponsesExcelGetPath = '/Excel/CreateFormBuilderResponsesExcel';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateFormBuilderResponsesExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateFormBuilderResponsesExcelGet$Response(params?: ExcelCreateFormBuilderResponsesExcelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelCreateFormBuilderResponsesExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateFormBuilderResponsesExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelCreateFormBuilderResponsesExcelGet(params?: ExcelCreateFormBuilderResponsesExcelGet$Params, context?: HttpContext): Observable<Blob> {
    return this.excelCreateFormBuilderResponsesExcelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `excelCreateFormBuilderResponsesExcelPost()` */
  static readonly ExcelCreateFormBuilderResponsesExcelPostPath = '/Excel/CreateFormBuilderResponsesExcel';

  /**
   * درخواست برای ساختن اکسل پاسخ های فرم ساز.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelCreateFormBuilderResponsesExcelPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateFormBuilderResponsesExcelPost$Response(params: ExcelCreateFormBuilderResponsesExcelPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelCreateFormBuilderResponsesExcelPost(this.http, this.rootUrl, params, context);
  }

  /**
   * درخواست برای ساختن اکسل پاسخ های فرم ساز.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelCreateFormBuilderResponsesExcelPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelCreateFormBuilderResponsesExcelPost(params: ExcelCreateFormBuilderResponsesExcelPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelCreateFormBuilderResponsesExcelPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelGetExcelsWithPagination()` */
  static readonly ExcelGetExcelsWithPaginationPath = '/Excel/GetExcelsWithPagination';

  /**
   * دریافت اکسل ها با صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelGetExcelsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelGetExcelsWithPagination$Response(params: ExcelGetExcelsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetExcelsWithPaginationDto>> {
    return excelGetExcelsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت اکسل ها با صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelGetExcelsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelGetExcelsWithPagination(params: ExcelGetExcelsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetExcelsWithPaginationDto> {
    return this.excelGetExcelsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetExcelsWithPaginationDto>): CustomResultOfPaginatedListOfGetExcelsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `excelDownload()` */
  static readonly ExcelDownloadPath = '/Excel/Download';

  /**
   * دانلود فایل اکسل.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelDownload()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelDownload$Response(params: ExcelDownload$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfByteOf>> {
    return excelDownload(this.http, this.rootUrl, params, context);
  }

  /**
   * دانلود فایل اکسل.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelDownload$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelDownload(params: ExcelDownload$Params, context?: HttpContext): Observable<CustomResultOfByteOf> {
    return this.excelDownload$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfByteOf>): CustomResultOfByteOf => r.body)
    );
  }

  /** Path part for operation `excelUpdateStatus()` */
  static readonly ExcelUpdateStatusPath = '/Excel/UpdateStatus';

  /**
   * ویرایش وضعیت لیست اکسل ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelUpdateStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelUpdateStatus$Response(params: ExcelUpdateStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return excelUpdateStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش وضعیت لیست اکسل ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelUpdateStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  excelUpdateStatus(params: ExcelUpdateStatus$Params, context?: HttpContext): Observable<CustomResult> {
    return this.excelUpdateStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `excelUpdateStatusToArchive()` */
  static readonly ExcelUpdateStatusToArchivePath = '/Excel/UpdateStatusToArchive';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelUpdateStatusToArchive()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelUpdateStatusToArchive$Response(params?: ExcelUpdateStatusToArchive$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return excelUpdateStatusToArchive(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelUpdateStatusToArchive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  excelUpdateStatusToArchive(params?: ExcelUpdateStatusToArchive$Params, context?: HttpContext): Observable<Blob> {
    return this.excelUpdateStatusToArchive$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
